import { Condition } from "./condition";

export class TableColumnsSum{

    constructor(){

    }

    Columns: string[];
    IncludeFirstRow: boolean;
    IncludePreviousSum: boolean;
    Condition: Condition;

    LoadTableColumnsSum(data: any){
        let tableColumnsSums: TableColumnsSum[] = [];
        let tableColumnsSum: TableColumnsSum;
        if(data){
            data.forEach(tableColumnsSumItem => {
                tableColumnsSum = new TableColumnsSum();

                tableColumnsSum.Columns = tableColumnsSumItem.columns ? tableColumnsSumItem.columns : [];
                tableColumnsSum.IncludeFirstRow = tableColumnsSumItem.includeFirstRow ? tableColumnsSumItem.includeFirstRow : true;
                tableColumnsSum.IncludePreviousSum = tableColumnsSumItem.includePreviousSum ? tableColumnsSumItem.includePreviousSum : false;
                tableColumnsSum.Condition = new Condition().LoadData(tableColumnsSumItem.condition);

                tableColumnsSums.push(tableColumnsSum);
            });
            
        }
        return tableColumnsSums;
    }
}